export default {
  1: 'No',
  2: 'Validando',
  3: 'Validada',
  4: 'Fallida',
  7: 'Pagando',
  10: 'Pagada',
}
